export class UnreachableCaseError<T> extends Error {
  constructor(val: T) {
    super(`Unreachable case: ${JSON.stringify(val)}`);
  }
}
